import React, { useState } from 'react';
import { useKickAuth } from './providers/Auth/KickProvider';

const BACKEND_URL = process.env.REACT_APP_KICK_OAUTH_SERVICE || 'http://localhost:4000';

const KickLoginButton = () => {
  const { isLoggedIn, isLoading, logout } = useKickAuth();
  const [buttonLoading, setButtonLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleKickLogin = () => {
    const currentUrl = window.location.href;
    setButtonLoading(true);
    window.location.href = `${BACKEND_URL}/kick?redirect=${encodeURIComponent(currentUrl)}`;
  };

  const handleLogout = async () => {
    setButtonLoading(true);
    setMessage('');
    try {
      await logout();
      setMessage('You have been logged out of Kick successfully.');
      
      // Clear message after 3 seconds
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      console.error('Error logging out [Kick]:', error);
      setMessage('An error occurred while logging out. Please try again.');
    } finally {
      setButtonLoading(false);
    }
  };

  // Show loading state while checking auth on mount
  if (isLoading) {
    return (
      <div className="login-button kick-login">
        <button disabled>Checking...</button>
      </div>
    );
  }

  return (
    <div className="login-button kick-login">
      <button
        onClick={isLoggedIn ? handleLogout : handleKickLogin}
        disabled={buttonLoading}
      >
        {buttonLoading
          ? isLoggedIn
            ? 'Logging out...'
            : 'Connecting...'
          : isLoggedIn
          ? 'Logout Kick'
          : 'Connect Kick'}
      </button>
      {message && <p className="logout-message">{message}</p>}
    </div>
  );
};

export default KickLoginButton;